import ComponentUtil from 'commonJsPath/edge/api/gw-portals-util-js/ComponentUtil';
import appFeatures from 'effective-features!';

class FooterCtrl {

    constructor($scope, PresentationMetadataHeaderAndFooter) {
        this.setCtrlParam = ComponentUtil.setCtrlParam(this, $scope);
        this.PresentationMetadataHeaderAndFooter = PresentationMetadataHeaderAndFooter;
        this.isMetadataEnabled = appFeatures.footerEnabled;
        this.setFooterItemsUsingMetadata();
    }

    setFooterItemsUsingMetadata() {
        if (this.isMetadataEnabled) {
            var tempJson = {
                "footer": {
                    "leftItems": [
                        {
                            "text": "footer.left_items.Accessibility",
                            "link": "#/faq/"
                        },
                        {
                            "text": "footer.left_items.Terms Of Use",
                            "link": "#/faq/"
                        },
                        {
                            "text": "footer.left_items.Privacy Policy",
                            "link": "#/faq/"
                        }
                    ],
                    "rightItems": [
                        {
                            "text": "footer.right_items.Copyright &copy; 2001-2018 Guidewire Software"
                        }
                    ]
                }
            };
            this.setCtrlParam('leftItems', tempJson.footer.leftItems);
            this.setCtrlParam('rightItems', tempJson.footer.rightItems);
            this.setCtrlParam('containsFooterMetadata', true);
            /*this.PresentationMetadataHeaderAndFooter.getFooterMetadata().then(footerMetadata => {
                if (footerMetadata) {
                    this.setCtrlParam('leftItems', footerMetadata.leftItems);
                    this.setCtrlParam('rightItems', footerMetadata.rightItems);
                    this.setCtrlParam('containsFooterMetadata', true);
                }
            });*/
        }
    }

    concatFooterItems() {
        if (this.containsFooterMetadata && this.leftItems && this.rightItems) {
            return this.leftItems.concat(this.rightItems);
        }
    }
}

FooterCtrl.$inject = ['$scope', 'PresentationMetadataHeaderAndFooter'];
export default FooterCtrl;